import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { PersonAutocomplete } from 'src/components/PersonAutocomplete/PersonAutocomplete';
import { getSearchState } from 'src/store/search/selectors';
import { searchActions } from 'src/store/search/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { SearchFilterButton } from '../SearchFilters/SearchFiltersSidesheet/SearchFilterButton';

import classes from './SearchActions.module.scss';

export const SearchActions: FC = () => {
  const dispatch = useAppDispatch();
  const { employee } = useSelector(getSearchState);

  const setEmployee = useCallback(
    (value: Option<string> | null) => {
      dispatch(searchActions.setEmployee(value));
    },
    [dispatch],
  );

  const clearEmployee = useCallback(() => {
    dispatch(searchActions.setEmployee(null));
  }, [dispatch]);

  return (
    <div className={classes.actions}>
      <div className={classes.search}>
        <PersonAutocomplete
          type='search'
          placeholder='ФИО коллеги'
          key={employee?.id}
          value={employee}
          onChange={setEmployee}
          onInputClear={clearEmployee}
          onClear={clearEmployee}
        />
      </div>
      <div className={classes.controls}>
        <SearchFilterButton />
      </div>
    </div>
  );
};
